
document.addEventListener("DOMContentLoaded", function() {
  const scrollMap = {
    "#HeaderMenu-benefits": ".benefits-link",
    "#HeaderMenu-how-it-works": ".how-it-works",
    "#HeaderMenu-ingredients": ".ingredients-link",
    "#HeaderMenu-why-is-fiber-imortant": ".why-is-fiber-imp",
    "#HeaderMenu-reviews": ".review-link",
    ".herrobanner-desktop .banner__buttons a:nth-child(2)": ".how-it-works",
    ".herrobanner-desktop .banner__buttons.banner__buttons--multiple a:first-child": ".featured-product .product__title",
    ".anc-btn": ".featured-product .product__title",
    ".section-goff": ".featured-product .product__title"
    
  };

  Object.entries(scrollMap).forEach(([triggerSelector, targetSelector]) => {
    document.querySelectorAll(triggerSelector).forEach(trigger => {
      trigger.addEventListener("click", function(e) {
        e.preventDefault();
        const target = document.querySelector(targetSelector);
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });
  });
  function rechargewid(){ 
      const widgetTarget = document.querySelector('.recharge-widget-appe');
      const productInfo = widgetTarget ? widgetTarget.closest('[data-product-id]') : null;
      const fallbackInfo = document.querySelector('[data-product-id]');
      const dynamicProductId = productInfo ? productInfo.getAttribute('data-product-id') : (fallbackInfo ? fallbackInfo.getAttribute('data-product-id') : '9182342316343');

      const config = {
        productId: parseInt(dynamicProductId, 10),
        injectionParent: '.recharge-widget-appe',
        injectionMethod: 'append', // or 'append'
        selectors: {
          price: ['.price-item--regular'],
          variant: ['.product-form__input input[type="radio"]']
        }
      };

      if (window.ReChargeWidget) {
        window.ReChargeWidget.createWidget(config);
      } else {
        const script = document.createElement('script');
        script.src = 'https://static.rechargecdn.com/static/js/widget.js';
        
        document.body.appendChild(script);
        script.onload = () => window.ReChargeWidget.createWidget(config);
        window.ReChargeWidget.createWidget(config);
      }
        function runTask() {
          const selectedPricet = document.querySelector('.rc_widget__option__selector input[type="radio"]:checked')?.closest('.rc_widget__option__selector ')?.querySelector('.rc_widget__price')?.innerText.trim();
          const jugprice = document.querySelector('p.jug-price');
          jugprice.innerText = selectedPricet;   


          const radiovar = document.querySelector('.variant-sect input[type="radio"]:checked');
                          if (radiovar) {
                          radiovar.click();
                      }  
          }

          [300, 500, 1000].forEach(delay => {
            setTimeout(runTask, delay);
          });
        const variantRadios = document.querySelectorAll('.product__info-container');

        variantRadios.forEach(radio => {
          radio.addEventListener('change', function () {
            setTimeout(() => {
              const activePriceEl = document.querySelector('.rc-widget__option--active .rc-option__price');
              if (activePriceEl) {
                const updatedPrice = activePriceEl.innerText;
                const targetPriceEl = document.querySelector('.price-item--regular');
                if (targetPriceEl) {
                  targetPriceEl.innerText = updatedPrice;
                }
              }
              function runTaskt() {
              const selectedPricet = document.querySelector('.rc_widget__option__selector input[type="radio"]:checked')?.closest('.rc_widget__option__selector ')?.querySelector('.rc_widget__price')?.innerText.trim();
              const selectedPrice = document.querySelector('.variant-sect input[type="radio"]:checked')?.closest('.variant-sect')?.querySelector('.variant-price');
              const jugpricet = document.querySelector('p.jug-price');
                    selectedPrice.innerText = selectedPricet;
                    jugpricet.innerText = selectedPricet;

                    const radiorcw = document.querySelector('.rc_widget__option--active input[type="radio"]:checked');
                          if (radiorcw) {
                          radiorcw.click();
                            }     
                }

                [300, 500, 1000].forEach(delay => {
                  setTimeout(runTaskt, delay);
                });

               
            }, 1000); 
          });
        });

  }

const checkInterval = setInterval(function() {
  const target = document.querySelector('.recharge-widget-appe'); // Replace with your class
 
  if (target) {

     rechargewid();
     setTimeout(() => {
       }, 1000); 
    clearInterval(checkInterval);
  }
}, 200); 


document.querySelectorAll('.variant-sect').forEach(box => {
  box.addEventListener('click', () => {
    const radio = box.querySelector('input[type="radio"]');
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true })); // trigger change
  });
});
});